module.exports = __webpack_public_path__ + "static/media/3.30434005.png";